






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { HeaderTabType } from '@/config/page-tab';
import '@tencent/bk-icon-wphk-ui';
import { isTabShowed, markShowedTabTips } from '@/business/header-tab/tips';
import { i18n } from '@/i18n';
import { biHT } from '@/business/bi';

@Component
export default class TabTips extends Vue {
  /** tab id */
  @Prop() tabKey!: string;
  /** tab是否激活 */
  @Prop() isTabActive!: boolean;
  /** 是否展示标签的tips */
  isShowTips = false;
  /** 提示内容 */
  get tipsContent() {
    const map = {
      [HeaderTabType.displaycouponlist]: i18n('你的「商戶電子優惠券」可點此查看並使用'),
    };
    return map[this.tabKey];
  }
  @Watch('isTabActive')
  handleTabActive(newShowStatus, oldShowStatus) {
    // tab激活时，标记已展示
    if (newShowStatus && !oldShowStatus) {
      this.markShowedTips();
    }
  }
  created() {
    this.isShowTips = !!this.tipsContent && !isTabShowed(this.tabKey);
    if (this.isShowTips) {
      biHT('promozone.myasset.tab_tips_brow', {
        ftabid: this.tabKey,
      });
    }
  }
  handleClickCloseTip() {
    this.markShowedTips();
    biHT('promozone.myasset.tab_tips_close_click', {
      ftabid: this.tabKey,
    });
  }
  /** 标记已展示过tips */
  markShowedTips() {
    if (this.isShowTips) {
      this.isShowTips = false;
      markShowedTabTips(this.tabKey);
    }
  }
}
